export const REGEX = {
  LINE_BREAK: /[\r\n]+/g,
  SPACE: /\s+/g,
  ENGLISH_LETTERS: /^[a-zA-Z]+$/,
  RUSSIAN_LETTERS: /[\u0401\u0451\u0410-\u044f]/g,
  MODEL_CODE_REPLACE_PATTERN: /[^a-zA-Z0-9_-]/g,
  CONTAINER_ID: /(containerId):/g,
  REPLACE_ONLY_NUMBER: /(?!^-)\D/,
  ONLY_NUMBER: /^-?\d*\d*$/,
  ASSISTANT_FORBIDDEN_CHARS: /^[^()]*$/,
  HEX_COLORS: /^#?[0-9A-Fa-f]{0,6}$/,
  REF_BY_ID: /_ref/,
  GLOBAL_VARIABLE: /\b(?:global)\b/,
  FORM_VARIABLE: /\b(?:form)\b/,
  WINDOW_VARIABLE: /\b(?:window)\b/,
  DELETE_ALL_SYMBOLS_BEFORE_FIRST_UNDERLINING: /^[^_]*_/,
  CHECK_PATH_START_FROM_NUMBER: /^\/\d[\w -]*$/i,
  CHECK_LETTERS_DASH_UNDERLINE_WHITESPACE_NUMBERS: /^[a-zA-Zа-яА-ЯёЁ0-9_\-\s()]+$/,
  NUMBER_REGEX: /^-?[0-9]+$/,
}
